"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerWithAddressResponse = void 0;
class PartnerWithAddressResponse {
}
exports.PartnerWithAddressResponse = PartnerWithAddressResponse;
//# sourceMappingURL=partner-address.response.js.map